import { z } from 'zod'

/**
 * A form body carries only strings. The browser sends a nested value as bracket
 * keys, which `inputFromForm` rebuilds into an array or an object, but the API
 * gateway sends it as its JSON text instead, and `coerceValue` in `remix-forms`
 * leaves that string alone. Wrap such a field so both shapes parse.
 */
export function jsonish<Schema extends z.ZodTypeAny>(schema: Schema) {
  return z.preprocess((value) => {
    if (typeof value !== 'string') return value

    const text = value.trim()
    if (!/^[[{]|^null$/.test(text)) return value

    try {
      return JSON.parse(text)
    } catch {
      return value
    }
  }, schema)
}
